// extracted by mini-css-extract-plugin
export default {"right":"rightStyles_right__lzC0+","bump":"rightStyles_bump__UFjNZ","wrong":"rightStyles_wrong__apfn6"};